/** @deprecated */
type Category = {
	id: number;
	name: string;
};

/** @deprecated */
const categories: Category[] = [
	{ id: 1, name: 'All Category' },
	{ id: 2, name: 'Plush' },
	{ id: 2, name: 'Creation' },
	{ id: 2, name: 'Birthday Parties' },
	{ id: 2, name: 'Clearance' },
];

export default categories;
